import {connect} from "react-redux";
import PaymentDetails from "./PaymentDetails";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../services/redux/fileUpload/action";
import {
    loanPaymentRaiseRequest,
    loanAccountRequest,
    loanApplicationByIdRequest,
    loanTranchesRequest,
    loanPaymentRequestRequest,
    updateTrancheStatusRequest,
    caseStatusUpdateRequest,
    loanApprovalRequestRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    loanApplicationUpdateResponse: state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse: state.CarLoan.loanAccountResponse,
    loanApplicationByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanTranchesResponse : state.CarLoan.loanTranchesResponse,
    loanPaymentRequestResponse : state.CarLoan.loanPaymentRequestResponse,
    updateTrancheStatusResponse : state.CarLoan.updateTrancheStatusResponse,
    loanApprovalRequestResponse : state.CarLoan.loanApprovalRequestResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            loanTranchesRequest,
            loanApplicationByIdRequest,
            loanAccountRequest,
            loanPaymentRaiseRequest,
            loanPaymentRequestRequest,
            updateTrancheStatusRequest,
            caseStatusUpdateRequest,
            loanApprovalRequestRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetails);
